import { MapEventOf, MapEventType } from 'mapbox-gl';
import { useEffect } from 'react';
import { useMap } from 'react-map-gl/mapbox';

import { LayerNameEnum } from '@/types/map.types';

export const useMapLayerMouseEvent = <T extends MapEventType>(
  interactionType: T,
  listener: (event: MapEventOf<T>) => void,
  layer?: LayerNameEnum | LayerNameEnum[],
) => {
  const { current: mapbox } = useMap();

  useEffect(() => {
    if (mapbox) {
      if (layer) {
        mapbox.on(interactionType, layer, listener);
      } else {
        mapbox.on(interactionType, listener);
      }
    }
    return () => {
      if (mapbox) {
        if (layer) {
          mapbox.off(interactionType, layer, listener);
        } else {
          mapbox.off(interactionType, listener);
        }
      }
    };
  }, [interactionType, layer, listener, mapbox]);
};
